<template>
    <div :class="{disabled: disabled}" >
        <label >
            <div style="display: flex">
                <input :disabled="disabled" type="radio" :name="name" :value="value" v-model="model" :class="inputClass">
                <span class="__radio-circle"><span class="__radio-circle-inside" :class="{'disabled': disabled}"></span></span>
                <span>{{ label }}</span>
            </div>
        </label>
    </div>
</template>
<style scoped>
    div.disabled {
        opacity: 0.3;
    }
    label {
        display: block;
        cursor: pointer;
        position: relative;
        margin: 0;
        font-size: 13px;
    }

    input {
        width: 0;
        height: 0;
        border: none;
        background: none;
        margin: 0;
        padding: 0;
        outline: none;
        opacity: 0;
        position: absolute;
    }

    input.__radio-type-circle + span {
        border-radius: 50%;
        display: inline-block;
        position: relative;
        width: 18px;
        height: 18px;
        margin-right: 8px;
        background-color: #FFF;
        box-shadow: inset 0px 0px 1px 1px #ccc;
        flex-shrink: 0;
    }

    input.__radio-type-circle:focus + span {
        box-shadow: inset 0px 0px 1px 1px #00BFFF;
        outline: none;
    }

    input.__radio-type-circle:checked + span > span {
        border-radius: 50%;
        background-color: #00BFFF;
        display: block;
        position: absolute;
        top: 4px;
        left: 4px;
        right: 4px;
        bottom: 4px;
    }

    input.__radio-type-square + span {
        display: inline-block;
        position: relative;
        width: 18px;
        height: 18px;
        margin-right: 8px;
        background-color: #FFF;
        box-shadow: inset 0px 0px 1px 1px #ccc;
        flex-shrink: 0;
    }

    input.__radio-type-square:focus + span {
        box-shadow: inset 0px 0px 1px 1px #00BFFF;
        outline: none;
    }

    input.__radio-type-square:checked + span > span::after {
        /* background-color: #00BFFF; */
        display: block;
        position: absolute;
        top: 4px;
        left: 3px;
        right: 4px;
        bottom: 4px;
        content: '\f00c';
        font-family: FontAwesome;
        font-size: 13px;
        color: #00BFFF;
        line-height: 11px;
    }
</style>
<script>
    import Input from './generic/input'

    export default {
        mixins: [Input],
        name: 'form-radio',
        props: {
            inline: {
                default: false,
                type: Boolean
            },
            value: {
                required: true
            },
            name: {
                default: null
            },
            type: {
                type: String,
                default: 'circle'
            },
            label: {
                type: String,
                default: null
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            inputClass () {
                return `__radio-type-${this.type}`
            }
        }
    }
</script>



// WEBPACK FOOTER //
// Radio.vue?0e8a51b6